import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import "rxjs/add/operator/filter";
import { InicioService } from "src/app/inicio/inicio/inicio.service";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-nav-bar",
  templateUrl: "./nav-bar.component.html",
  styleUrls: ["./nav-bar.component.scss"],
  
})
export class NavBarComponent implements OnInit {
  idToken: string;
  option: string;
  cidi:string;
  actions = ["Portal SIGEMyT", "CIDI-Ciudadano Digital"];
 // actions = ["Portal SIGEMyT"];
 
  constructor(
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private service: InicioService
  ) {}

  ngOnInit() {
    debugger;
    this.route.queryParams
      .filter((params) => params.token)
      .subscribe((params) => {
        this.idToken = params.token;
        const token = params.token;
        sessionStorage.setItem("id_token", token);
      });

      //cidi
      
      this.route.queryParams
      .filter((params) => params.cidi)
      .subscribe((params) => {
        this.cidi = params.cidi;
        const cidi = params.cidi;
        sessionStorage.setItem("cidi", cidi);
        debugger;
      });

    this.idToken = sessionStorage.getItem("id_token");

    this.cidi = sessionStorage.getItem("cidi");
  }

  onChange(): void {
    debugger;

    if (this.option == "CIDI-Ciudadano Digital") {
      window.open("https://cidi.test.cba.gov.ar/", "_self");
     this.cidi;
    } else {
      window.open(`${environment.urlportal}`, "_self");
    }
  }

  cerrarSesion(): void {
    sessionStorage.clear();
  }
}
